/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { ChevronRightIcon, colors, spacing, Text } from "@packages/ui";
import { memo, type MouseEventHandler } from "react";

const footerStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: spacing.s,
  justifyContent: "flex-start",
  marginTop: spacing.l,
};
const reportButtonStyle: Interpolation = {
  alignItems: "center",
  background: colors.transparent,
  border: spacing.none,
  color: "inherit",
  cursor: "pointer",
  display: "flex",
  justifyContent: "flex-start",
  outline: spacing.none,
  padding: spacing.none,
  ":hover": {
    textDecoration: "underline",
  },
  ":focus": {
    outline: spacing.none,
  },
};

interface TranscriptFooterProps {
  onReport: MouseEventHandler<HTMLButtonElement>;
  isAutotranscribed: boolean;
}

export const TranscriptFooter = memo(
  ({ onReport, isAutotranscribed }: TranscriptFooterProps) => {
    const t = useTranslations();

    return (
      <div css={footerStyle}>
        {isAutotranscribed && (
          <Text type={"body"} size={"s"}>
            {t("transcript_auto_transcribed")}
          </Text>
        )}
        {isAutotranscribed && onReport && (
          <Text type={"body"} size={"s"}>
            •
          </Text>
        )}
        {onReport && (
          <button onClick={onReport} css={reportButtonStyle}>
            <Text type={"body"} size={"s"}>
              {t("transcript_report_concern")}
            </Text>
            <ChevronRightIcon />
          </button>
        )}
      </div>
    );
  },
);
